<div class="container">
    <h3>{{currentPlannedSession.trainingTitle}}</h3>
    <div *ngIf="training && training.materialReady === false">
        <p>
            <span class="times">
                <i class="fa fa-warning" aria-hidden="true"></i>
                {{ 'global.materialNotReadyWarning' | translate }}
            </span>
        </p>
    </div>
    <div class="form-group detail">
        <div class="row">
            <div class="col-md-1">
                <label for="startDate">{{
                    'planned-session-detail.date' | translate
                }}</label>
            </div>
            <div class="col-md-2">
                <input
                    type="date"
                    class="form-control"
                    id="startDate"
                    required
                    #name="ngModel"
                    name="startDate"
                    [(ngModel)]="plannedSession.startDate"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-1">
                <label for="trainerId">{{
                    'planned-session-detail.trainer' | translate
                }}</label>
            </div>
            <div class="col-md-3">
                <input
                    auto-complete
                    [(ngModel)]="plannedSession.trainer"
                    [source]="searchTrainers.bind(this)"
                    [list-formatter]="formatTrainer.bind(this)"
                    id="trainerId"
                    class="form-control"
                    [accept-user-input]="false"
                    [min-chars]="1"
                    [max-num-list]="14"
                    display-property-name="fullName"
                    required
                    autocomplete="off"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-1">
                <label for="agencyId">{{
                    'planned-session-detail.agency' | translate
                }}</label>
            </div>
            <div class="col-md-3">
                <input
                    auto-complete
                    [(ngModel)]="plannedSession.agency"
                    [source]="agencies"
                    [list-formatter]="formatAgency.bind(this)"
                    [value-formatter]="formatAgency.bind(this)"
                    id="agencyId"
                    class="form-control"
                    [accept-user-input]="false"
                    required
                    autocomplete="off"
                />
            </div>
        </div>
        <br />
        <button class="btn btn-default" (click)="save()">
            {{ 'planned-session-detail.save' | translate }}
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/planning/detail/detail.component.html